import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 1252 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1252 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-member\"><path d=\"M1234.662924 122.019441a36.090589 36.090589 0 0 0-40.637435 0l-258.033506 192.672596L654.087536 13.179317a37.227301 37.227301 0 0 0-56.835574 0L313.074092 316.112926 57.31401 123.440331a36.090589 36.090589 0 0 0-40.637436 0A35.806412 35.806412 0 0 0 0.478436 159.53092L187.467474 995.582213a35.806412 35.806412 0 0 0 34.6697 28.417787h807.06515a35.806412 35.806412 0 0 0 34.6697-28.417787L1250.861063 159.53092a35.806412 35.806412 0 0 0-16.198139-37.511479z m-424.845915 426.266805L654.087536 754.031024a35.522234 35.522234 0 0 1-28.417787 14.208893 35.522234 35.522234 0 0 1-28.417787-13.924715l-155.445295-205.4606a35.607487 35.607487 0 0 1 56.835574-42.910859L625.669749 673.892864l127.880042-168.233299a35.607487 35.607487 0 1 1 56.835574 42.910859z\" p-id=\"4747\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member.svg
// module id = /LrJ
// module chunks = 56